import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-wrap" }
const _hoisted_2 = {
  class: "ui basic unstackable table",
  id: "table"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { id: "status4" }, "运行状态", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { id: "name" }, "节点名", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { id: "type" }, "类型", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { id: "location" }, "服务器位置", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { id: "uptime" }, "在线时间", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { id: "load" }, "负载", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { id: "network" }, "网络(B/s) ↓|↑", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { id: "traffic" }, "流量(B) ↓|↑", -1)
const _hoisted_11 = {
  key: 0,
  id: "monthly"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { id: "cpu" }, "CPU", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { id: "ram" }, "内存", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { id: "hdd" }, "硬盘", -1)
const _hoisted_15 = { id: "servers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_item = _resolveComponent("table-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          (_ctx.trafficEnabled)
            ? (_openBlock(), _createElementBlock("th", _hoisted_11, "本月流量"))
            : _createCommentVNode("", true),
          _hoisted_12,
          _hoisted_13,
          _hoisted_14
        ])
      ]),
      _createElementVNode("tbody", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servers, (server, index) => {
          return (_openBlock(), _createBlock(_component_table_item, {
            key: index,
            server: server
          }, null, 8, ["server"]))
        }), 128))
      ])
    ])
  ]))
}